import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const TOAST_ID = 'edit-manager-config';

export const editManagerConfig: managerTypes.EditManagerConfig = (data) => {
  return axios.put(`/manager/config`, data);
};

type UseEditManagerConfigOptions = {
  department: Departments;
  config?: MutationConfig<typeof editManagerConfig>;
};

export function useEditManagerConfig({ config = {}, department }: UseEditManagerConfigOptions) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      managerMutationToasts.loading(TOAST_ID, 'Updating manager...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['managers', department]);
      managerMutationToasts.success(TOAST_ID, 'Manager updated successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: editManagerConfig,
  });
}
